var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCircleRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6ZM4.48481 4.48482C4.63126 4.33838 4.8687 4.33838 5.01514 4.48482L5.99998 5.46967L6.98481 4.48484C7.13126 4.33839 7.3687 4.33839 7.51514 4.48484C7.66159 4.63128 7.66159 4.86872 7.51514 5.01517L6.53031 6L7.51513 6.98481C7.66158 7.13126 7.66158 7.3687 7.51513 7.51515C7.36869 7.66159 7.13125 7.66159 6.9848 7.51515L5.99998 6.53033L5.01515 7.51515C4.86871 7.6616 4.63127 7.6616 4.48482 7.51515C4.33838 7.36871 4.33838 7.13127 4.48482 6.98483L5.46965 6L4.48481 5.01515C4.33837 4.86871 4.33837 4.63127 4.48481 4.48482Z",
    fill: "#E31C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleRed);
export default __webpack_public_path__ + "static/media/closeCircleRed.dcfc91459d7de5f431a234f6bbbb6d18.svg";
export { ForwardRef as ReactComponent };